<template>
  <div>
    <default>

      <flowbite-modal btn-name="přidat" name="přidat zákazníka">
        <template #modal-content>
          <create-customer-form />
        </template>
      </flowbite-modal>


      <div class="flex items-center justify-between mb-4">
        <h1 class="text-2xl font-bold">Zákazníci</h1>
        <div class="flex space-x-3">
          <button @click="fetchCustomers" :disabled="isLoading"
                  class="flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300">
            <svg v-if="isLoading" class="animate-spin h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v2a6 6 0 100 12v2a8 8 0 01-8-8z"></path>
            </svg>
            <span>{{ isLoading ? 'Načítám...' : 'Obnovit' }}</span>
          </button>

          <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input
                v-model="search"
                @input="debouncedFetch"
                type="text"
                class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
                placeholder="Hledat jméno, email, telefon..."
            >
          </div>
        </div>
      </div>
      <!--      <p class="mb-4">Zde můžete vidět všechny objednávky, které byly zaznamenány v aplikaci.</p>-->

      <!-- Loading Spinner -->
      <div v-if="isLoading && !customers.length " class="flex justify-center items-center my-4">
        <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
      </div>


      <div v-else :class="{ 'opacity-50': isLoading }" class="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>

            <th scope="col" class="px-6 py-3">
              jméno
            </th>
            <th scope="col" class="px-6 py-3">
              email
            </th>
            <th scope="col" class="px-6 py-3">
              telefon
            </th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="customer in customers" :key="customer.id"
              @click="$router.push({ name: 'customer-detail', params: {customerId: customer.id}})"
              class="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
            <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
              {{customer.name}}
            </th>
            <td>
              {{customer.email}}
            </td>
            <td>
              {{customer.phone}}
            </td>
          </tr>

          </tbody>
        </table>
        <nav class="flex items-center flex-column flex-wrap md:flex-row justify-between py-4 px-6"
             aria-label="Table navigation">
          <div>
            <label for="limit" class="mr-2 text-sm text-gray-700">Počet na stránku:</label>
            <select v-model="limit" @change="fetchCustomers" id="limit"
                    class="text-sm text-gray-700 bg-white border border-gray-300 rounded-md h-8 px-3 py-0">
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
          </div>
          <div>
          <span
              class="text-sm font-normal text-gray-500 dark:text-gray-400 mb-4 md:mb-0 block w-full md:inline md:w-auto">Zobrazuji
            <span class="font-semibold text-gray-900 dark:text-white">{{
                (currentPage - 1) * limit + 1
              }} - {{ customers.length }}</span>
            z <span class="font-semibold text-gray-900 dark:text-white">{{ totalCount }}</span></span>
          </div>

          <ul class="inline-flex -space-x-px rtl:space-x-reverse text-sm h-8">
            <li>
              <a href="#" @click="previousPage" :disabled="currentPage === 1"
                 class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Předchozí</a>
            </li>
            <template  v-for="page in totalPages" :key="page">
              <li v-if="Math.abs(currentPage - page) <= 3 || page === 1 || page === totalPages">
                <button @click="goToPage(page)"
                        :class="{'text-blue-600 bg-blue-50': currentPage === page, 'text-gray-500 bg-white': currentPage !== page}"
                        class="flex items-center justify-center px-3 h-8 leading-tight border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  {{ page }}
                </button>
              </li>
            </template>
            <li>
              <a href="#" @click="nextPage" :disabled="currentPage === totalPages"
                 class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Další</a>
            </li>
          </ul>
        </nav>
      </div>


    </default>
  </div>

</template>
<script lang="ts">
import Default from "@/layouts/admin/default.vue";
import {useAppStore} from "@/stores/appStore";
import {ResponseEntityCustomer} from "@haxo-cz/orders-ts-client";
import CreateCustomerForm from "@/components/forms/createCustomerForm.vue";
import FlowbiteModal from "@/components/flowbiteDynamic/flowbiteModal.vue";
import {debounce} from "lodash";

export default {
  name: "CustomersView",
  components: {FlowbiteModal, CreateCustomerForm, Default},
  data() {
    const appStore = useAppStore();
    return {
      appStore,
      customers: [] as ResponseEntityCustomer[],
      currentPage: 1,
      totalPages: 1, // Total number of pages, initialized
      limit: 10,
      dateFrom: "",
      dateTo: "",
      status: "",
      search: "",
      sortBy: "createdAt",
      sortOrder: "desc",
      isLoading: false, // New loading state variable
      totalCount: 0,
    };
  },
  methods: {
    debouncedFetch() {
      this.currentPage = 1;
      this.fetchCustomers();
    },
    async fetchCustomers() {
      this.isLoading = true; // Set loading to true before fetching data
      try {
        const response = await this.$customersApi.findAllCustomers(
            this.appStore.selectedProject.spaceId,
            this.appStore.selectedProject._id,
            this.currentPage,
            this.limit,
            this.dateFrom ? this.dateFrom : undefined,
            this.dateTo ? this.dateTo : undefined,
            this.search ? this.search : undefined,
            this.sortBy,
            this.sortOrder
        );

        console.log(response);

        this.customers = response.data.data;
        this.totalPages = response.data.meta.pagination.pages;
        this.totalCount = response.data.meta.totalCount;
      } catch (error) {
        console.error("Chyba při načítání customers:", error);
      } finally {
        this.isLoading = false; // Set loading to false after data is fetched
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.isLoading = true;
        this.currentPage++;
        this.fetchCustomers();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchCustomers();
      }
    },
    goToPage(page: number) {
      if (page !== this.currentPage) {
        this.currentPage = page;
        this.fetchCustomers();
      }
    },
  },
  created() {
    this.debouncedFetch = debounce(this.debouncedFetch, 500);
  },
  mounted() {
    this.fetchCustomers();
  },
  beforeUnmount() {
    if (this.debouncedFetch && 'cancel' in this.debouncedFetch) {
      (this.debouncedFetch as any).cancel();
    }
  },
};
</script>